// editors/markdoc/decorationsRouter.js
import { decoratePairedMarks } from "./decorations/base";
import { decorateListMark } from "./decorations/list";
import { decorateImage } from "./decorations/image";
import { decorateLink } from "./decorations/link";
import { decorateHorizontalRule } from "./decorations/horizontalRule";
import { decorateTask, decorateTaskMarker } from "./decorations/task";
import { decorateATXHeading } from "./decorations/headings";

export function routeDecoration(node, view, widgets, mode) {

  // var text = view.state.doc.sliceString(node.from, node.to);
  // console.log(node.name, ":", text);

  // FencedCode, Tables, Blockquote, MarkdocTag
  //       => utils/renderBlock.js

  if (node.name.startsWith("ATXHeading"))
    return decorateATXHeading(node, view, widgets, mode);

  if (node.name === "Strikethrough")
    return decoratePairedMarks(node, view, widgets, { markTypeName: "StrikethroughMark", mode: mode });

  if (node.name === "Emphasis")
    return decoratePairedMarks(node, view, widgets, { markTypeName: "EmphasisMark", mode: mode });

  if (node.name === "StrongEmphasis")
    return decoratePairedMarks(node, view, widgets, { markTypeName: "EmphasisMark", mode: mode });

  if (node.name === "InlineCode")
    return decoratePairedMarks(node, view, widgets, { markTypeName: "CodeMark", mode: mode });

  if (node.name === "HorizontalRule")
    return decorateHorizontalRule(node, view, widgets, mode);

  if (node.name === "ListItem")
    return decorateListMark(node, view, widgets, { markTypeName: "ListMark", contentClass: "list-item", mode: mode });

  if (node.name === "Image")
    return decorateImage(node, view, widgets, mode);

  // TODO: Fix Implementation
  if (node.name === "Link")
    return decorateLink(node, view, widgets, mode); // Handels ![]() and [[zettel]] links

  if (node.name === "Task")
    return decorateTask(node, view, widgets, mode);

  // TODO: Implement
  if (node.name === "TaskMarker")
    return decorateTaskMarker(node, view, widgets, mode);

  return true
}
